import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton, FlexStack } from '~/components/atomic';
import Dart from '~/assets/img/icons/dart.svg';

interface BottomSheetInnerProps {
  dartCount: number;
  description: string;
  onClose: () => void;
}

export default function BottomSheetInner({
  dartCount,
  description,
  onClose,
}: BottomSheetInnerProps) {
  return (
    <Container>
      <FlexStack>
        <DartBackground>
          <img src={Dart} alt='dart_icon' />
          <DartCount>{dartCount}</DartCount>
        </DartBackground>
      </FlexStack>
      <FlexStack style={{ alignItems: 'center' }}>
        <TitleBox>
          <strong>Received!</strong>
        </TitleBox>
        <DescBox>
          <p>{description}</p>
        </DescBox>
      </FlexStack>

      <DefaultButton colorType='black' isBlocked onClick={onClose}>
        Confirm
      </DefaultButton>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const DartBackground = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 137px;
    height: 133px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_2};

    & > img {
      width: 60%;
    }
  `}
`;

export const DartCount = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: 10%;
    left: 10%;
    font-family: Poppins, 'serif';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -0.3px;
    line-height: 1.2;
  `}
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    display: block;

    strong {
      font-family: Poppins, 'serif';
      font-size: 20px;
      font-weight: 600;
      letter-spacing: -0.2px;
      line-height: 1.4;
    }
  `}
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: block;

    p {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.content_light_3};
      word-break: keep-all;

      em {
        color: ${theme.themeColor.main_1};
      }
    }
  `}
`;
